import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

let socketInstance = null;

export function useSocket() {
  const socketRef = useRef(null);

  useEffect(() => {
    if (!socketInstance) {
      socketInstance = io(
        process.env.REACT_APP_SOCKET_URL || 'http://localhost:3000',
        { transports: ['websocket'] }
      );
    }
    socketRef.current = socketInstance;
    return () => {};
  }, []);

  function on(evento, handler) {
    socketInstance?.on(evento, handler);
    return () => socketInstance?.off(evento, handler);
  }

  function emit(evento, dados) {
    socketInstance?.emit(evento, dados);
  }

  function entrarConversa(id)  { emit('entrar_conversa', id); }
  function sairConversa(id)    { emit('sair_conversa', id); }

  return { on, emit, entrarConversa, sairConversa };
}
